import { api } from "@/lib/api";

// Fire-and-forget visit/action tracking for the organizer's stats dashboard.
// Never awaited by callers, never throws, never blocks the guest's own action
// on it succeeding -- it's a nice-to-have count, not something a guest should
// ever notice failing.
export function trackEvent(slug, event, count = 1) {
  api.post(`/public/${slug}/track`, { event, count }).catch(() => {});
}
